import { signOut } from "firebase/auth";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";
import BrandLogo from "./BrandLogo";

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/", { replace: true });
  };

  return (
    <div className="nav-wrap">
      <nav className="nav">
        <Link className="brand" to="/">
          <BrandLogo compact />
        </Link>

        <div className="nav-links">
          <NavLink to="/pricing">Pricing</NavLink>
          {user ? <NavLink to="/dashboard">Dashboard</NavLink> : <NavLink to="/login">Login</NavLink>}
          {user ? <NavLink to="/team">Team</NavLink> : null}
          {user ? (
            <button className="ghost-button" onClick={handleLogout} type="button">
              Logout
            </button>
          ) : null}
        </div>
      </nav>
    </div>
  );
}
